import "./AboutPage.css";
import { whatsappLink } from "../config/site";
import useDocumentTitle from "../hooks/useDocumentTitle";

export default function AboutPage() {
  useDocumentTitle("About Us");

  return (
    <div className="about-page">

      {/* HERO */}

      <section className="about-hero">

        <div className="about-hero-left">
          <h1>ABOUT US</h1>

          <p>
            SAI CONCEPT is a fast-growing HoReCa distribution company based in Ranchi, Jharkhand, committed to delivering premium-quality food and hospitality products to hotels, restaurants, cafés, caterers, and institutional buyers across Eastern India. With a strong distribution network and deep market understanding, we specialize in sourcing and supplying high-demand categories including frozen foods, dairy products, cheese & pizza essentials, bakery ingredients, beverages, and kitchen essentials. Our focus is simple — reliable supply, competitive pricing, and consistent quality. We operate with a modern, efficient supply chain system supported by temperature-controlled storage and streamlined logistics to ensure freshness and timely delivery. Whether it’s a standalone restaurant or a large catering operation, we aim to be a trusted supply partner that helps businesses run smoothly and profitably. At SAI CONCEPT, we don’t just distribute products — we build long-term partnerships driven by trust, transparency, and growth..
          </p>

          <a
            href={whatsappLink("Hi Sai Concept, I would like to know more about your services.")}
            target="_blank"
            rel="noopener noreferrer"
            className="about-cta"
          >
            Talk To Us
          </a>
        </div>

        <div className="about-hero-right">
          <img
            src="https://i.postimg.cc/RF64Pp3h/Untitled-design-(1).jpg"
            alt="team"
          />
        </div>

      </section>


      {/* VALUES */}

      <section className="about-values">

        <div className="value-card">
          <h3>01</h3>
          <h4>Reliable Supply Chain</h4>
          <p>Strong sourcing network ensuring uninterrupted availability.</p>
        </div>

        <div className="value-card">
          <h3>02</h3>
          <h4>Quality Assured Products</h4>
          <p>Every product meets strict quality benchmarks.</p>
        </div>

        <div className="value-card">
          <h3>03</h3>
          <h4>Trusted Brand Partnerships</h4>
          <p>Working with top FMCG and food brands.</p>
        </div>

        <div className="value-card">
          <h3>04</h3>
          <h4>Future Ready Distribution</h4>
          <p>Modern logistics and scalable supply solutions.</p>
        </div>

      </section>


      {/* LEADERSHIP */}

      <section className="about-leadership">

        <h2 className="leadership-title">
          Meet The <span>Leadership</span>
        </h2>

        <div className="leader-card">

          <div className="leader-image">
            <img
              src="https://i.postimg.cc/sg0CGxbc/Whats-App-Image-2026-02-01-at-10-14-07-PM.jpg"
              alt="Founder"
            />
          </div>

          <div className="leader-content">

            <h3>MR. PRAMOD NANDE</h3>
            <span className="leader-role">Founder & Director</span>

            <p>
              Building a successful business requires more than just internal
              focus, it demands strong vendor partnerships and a deep
              understanding of market dynamics. By aligning trusted supplier
              networks with evolving customer needs, businesses can create
              sustainable supply chains and deliver consistent value.
            </p>

            <p>
              At SAI CONCEPT, the focus remains on long-term partnerships,
              operational efficiency, and delivering quality products that
              empower hospitality businesses to grow with confidence.
            </p>

          </div>

        </div>

      </section>

    </div>
  );
}